import type { BlockComponentStateId, BlockComponentType } from '../../types/block';
import type { FileType } from '../FileUpload/types';
import type { Message as BaseMessage } from '../CopilotChat/types';
import type { AutomationConfig } from '../Copilot/types';

type Content = {
  initialThreadId?: string;
  initialQuery?: string;
};

export type Appearance = {
  variant?: string;
};

type Slots = {
  copilotInputPanel?: {
    blockId: string;
  };
};

export type CopilotThreadComponentType = BlockComponentType<
  'CopilotThread',
  Content,
  Appearance,
  Slots
>;

export type CopilotThreadBlockStateType = Pick<
  CopilotThreadComponentType,
  'content' | 'appearance' | 'componentType' | 'slots'
> &
  BlockComponentStateId & {
    threadId?: string;
    automationsConfig?: AutomationConfig;
    summary?: string;
    isGeneratingResponse?: boolean;
    messages?: Message[];
  };

export type CopilotThreadBlockRef = {
  [CopilotThreadBlockMethods.SendMessage]: (input: {
    message?: string;
    attachments?: FileType[];
  }) => void;
  [CopilotThreadBlockMethods.GoToThread]: (threadId: string) => void;
  [CopilotThreadBlockMethods.CreateNewThread]: () => void;
  [CopilotThreadBlockMethods.StopResponseGeneration]: () => void;
};

export type CopilotThreadEvents = {
  onMessageSent: ({ message, attachments }: { message: string; attachments?: FileType[] }) => void;
  onCaseCreated: (caseId: string) => void;
};

export enum CopilotThreadBlockMethods {
  SendMessage = 'submitMessage',
  GoToThread = 'goToThread',
  CreateNewThread = 'createNewThread',
  StopResponseGeneration = 'stopResponseGeneration',
}

export type Message = BaseMessage & {
  searchQueryId?: string;
};
